'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TOOLBAR_MODES = exports.TOOLBAR_MODES = {
    ELEMENTS: 'ELEMENTS',
    SELECT: 'SELECT'
};

var TOOLS = exports.TOOLS = {
    RICH_TEXT: { id: 'RICH_TEXT', name: null, multiSelect: false },
    COLOR: { id: 'COLOR', name: 'Color', multiSelect: true },
    ICON: { id: 'ICON', name: 'Icon', multiSelect: false },
    CAPTION: { id: 'CAPTION', name: 'Caption', multiSelect: false },
    ATTACHMENT: { id: 'ATTACHMENT', name: 'Image', multiSelect: true },
    LOCK: { id: 'LOCK', name: 'Lock position', multiSelect: true },
    SHOW_BACKGROUND: { id: 'SHOW_BACKGROUND', name: 'Transparent', multiSelect: true },
    START_ARROW: { id: 'START_ARROW', name: 'Start', multiSelect: true },
    END_ARROW: { id: 'END_ARROW', name: 'End', multiSelect: true }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/toolbarConstants.js
// module id = 129
// module chunks = 0